export default __webpack_public_path__ + "static/media/pneusystem-login-img.4dce688f.png";